/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// DO NOT MODIFY
// FILE GENERATED BY `intl-codegen@2.2.1`
// https://github.com/eversport/intl-codegen
// DO NOT MODIFY

export default context => {
  const formatter_0 = context.d({ hour: "numeric", minute: "numeric" });
  const formatter_1 = context.d({ day: "numeric", month: "numeric", year: "2-digit" });
  const formatter_2 = context.d({ day: "numeric", month: "short", year: "numeric" });
  const formatter_3 = context.d({ day: "numeric", month: "long", year: "numeric" });
  const formatter_4 = context.d({ day: "numeric", month: "long", weekday: "long", year: "numeric" });
  const formatter_5 = context.m({});

  return [
    // `advantages_list_1`:
    // Simple and fast online booking - Everytime and everywhere
    params => "" +
      "Simple and fast online booking - Everytime and everywhere",

    // `advantages_list_2`:
    // All important booking information in one app
    params => "" +
      "All important booking information in one app",

    // `advantages_list_3`:
    // Always have your venue’s schedule and offers in your pocket
    params => "" +
      "Always have your venue’s schedule and offers in your pocket",

    // `authentication-facebook-login-error`:
    // It seems like you either cancelled or didn't accept our application permissions in facebook.
    params => "" +
      "It seems like you either cancelled or didn't accept our application permissions in facebook.",

    // `authentication-forgot-password-action`:
    // Forgot password?
    params => "" +
      "Forgot password?",

    // `authentication-google-login-error`:
    // It seems like you either cancelled or didn't accept our application permissions in google.
    params => "" +
      "It seems like you either cancelled or didn't accept our application permissions in google.",

    // `autocomplete-results-not-found`:
    // no results found
    params => "" +
      "no results found",

    // `autocomplete-searching`:
    // looking for...
    params => "" +
      "looking for...",

    // `back`:
    // Back
    params => "" +
      "Back",

    // `corona-guidelines`:
    // The current COVID regulations in the provider's region apply
    params => "" +
      "The current COVID regulations in the provider's region apply",

    // `date_unit_day`:
    // day
    params => "" +
      "day",

    // `date_unit_day_plural`:
    // Days
    params => "" +
      "Days",

    // `date_unit_game`:
    // Game
    params => "" +
      "Game",

    // `date_unit_game_plural`:
    // Games
    params => "" +
      "Games",

    // `date_unit_hour`:
    // Hours
    params => "" +
      "Hours",

    // `date_unit_hour_plural`:
    // Hours
    params => "" +
      "Hours",

    // `date_unit_minute`:
    // minute
    params => "" +
      "minute",

    // `date_unit_minute_plural`:
    // Minutes
    params => "" +
      "Minutes",

    // `date_unit_month`:
    // month
    params => "" +
      "month",

    // `date_unit_month_plural`:
    // Months
    params => "" +
      "Months",

    // `date_unit_season`:
    // season
    params => "" +
      "season",

    // `date_unit_season_plural`:
    // seasons
    params => "" +
      "seasons",

    // `date_unit_unit`:
    // unit
    params => "" +
      "unit",

    // `date_unit_unit_plural`:
    // Sessions
    params => "" +
      "Sessions",

    // `date_unit_week`:
    // week
    params => "" +
      "week",

    // `date_unit_week_plural`:
    // weeks
    params => "" +
      "weeks",

    // `date_unit_weekend`:
    // weekend
    params => "" +
      "weekend",

    // `date_unit_weekend_plural`:
    // weekends
    params => "" +
      "weekends",

    // `date_unit_year`:
    // year
    params => "" +
      "year",

    // `date_unit_year_plural`:
    // years
    params => "" +
      "years",

    // `date-range`:
    // {start} - {end}
    params => [
      params.start,
      " - ",
      params.end,
    ],

    // `date-time-range`:
    // {startDate} - {startTime} • {endDate} - {endTime}
    params => [
      params.startDate,
      " - ",
      params.startTime,
      " • ",
      params.endDate,
      " - ",
      params.endTime,
    ],

    // `default-error`:
    // An unexpected error happened. Please try again later.
    params => "" +
      "An unexpected error happened. Please try again later.",

    // `default-error-message`:
    // Something went wrong. Please try again later.
    params => "" +
      "Something went wrong. Please try again later.",

    // `error-message`:
    // Something went wrong. Please try again later.
    params => "" +
      "Something went wrong. Please try again later.",

    // `eversports`:
    // Eversports
    params => "" +
      "Eversports",

    // `family-account-account-owner`:
    // Account Owner
    params => "" +
      "Account Owner",

    // `family-account-banner-change-user`:
    // Change now
    params => "" +
      "Change now",

    // `family-account-banner-currently-booking-for`:
    // You're now booking for {loggedInUserName}.
    params => [
      "You're now booking for ",
      params.loggedInUserName,
      ".",
    ],

    // `family-account-banner-owner-disclaimer`:
    // For any purchases, the related invoice is billed to the account owner {ownerName}.
    params => "" +
      "For any purchases, the related invoice is billed to the account owner " +
      params.ownerName +
      ".",

    // `family-account-continue-with-selected-user`:
    // Continue with {selectedUserName}
    params => "" +
      "Continue with " +
      params.selectedUserName,

    // `family-account-create-new-family-member`:
    // Create a new family member
    params => "" +
      "Create a new family member",

    // `family-account-divider-text`:
    // OR
    params => "" +
      "OR",

    // `family-account-family-member`:
    // Family Member
    params => "" +
      "Family Member",

    // `family-account-new-member-continue`:
    // Create and continue
    params => "" +
      "Create and continue",

    // `family-account-new-member-description`:
    // Here you can create the family member you want to book for. Just complete the first and last name and click the button below, it's that simple.
    params => "" +
      "Here you can create the family member you want to book for. Just complete the first and last name and click the button below, it's that simple.",

    // `family-account-new-member-first-name-label`:
    // First Name
    params => "" +
      "First Name",

    // `family-account-new-member-go-back`:
    // Go back
    params => "" +
      "Go back",

    // `family-account-new-member-heading`:
    // Add new family member
    params => "" +
      "Add new family member",

    // `family-account-new-member-last-name-label`:
    // Last Name
    params => "" +
      "Last Name",

    // `family-account-select-user`:
    // Select a user to continue
    params => "" +
      "Select a user to continue",

    // `family-account-selection-heading`:
    // Choose the family member you want to book for
    params => "" +
      "Choose the family member you want to book for",

    // `full-format-date`:
    // {date, date, full}
    params => "" +
      formatter_4(params.date),

    // `long-format-date`:
    // {date, date, long}
    params => "" +
      formatter_3(params.date),

    // `medium-format-date`:
    // {date, date, medium}
    params => "" +
      formatter_2(params.date),

    // `monetary-value`:
    // {total, number, currency}
    params => "" +
      formatter_5(params.total),

    // `network-error-message`:
    // There seems to be a problem with your internet connection. Please try again later.
    params => "" +
      "There seems to be a problem with your internet connection. Please try again later.",

    // `newsletter-banner-action`:
    // Subscribe to Newsletter
    params => "" +
      "Subscribe to Newsletter",

    // `newsletter-banner-action-success`:
    // Subscribed!
    params => "" +
      "Subscribed!",

    // `newsletter-banner-subtitle`:
    // Always get the latest updates, news and insights from {venueName}.
    params => "" +
      "Always get the latest updates, news and insights from " +
      params.venueName +
      ".",

    // `newsletter-banner-title`:
    // Join the community of {venueName}!
    params => "" +
      "Join the community of " +
      params.venueName +
      "!",

    // `next`:
    // Continue
    params => "" +
      "Continue",

    // `no`:
    // No
    params => "" +
      "No",

    // `no-option`:
    // No Option
    params => "" +
      "No Option",

    // `not-found-message`:
    // Oops, seems there's no one playing around here.
    params => "" +
      "Oops, seems there's no one playing around here.",

    // `not-found-title`:
    // 404 Not Found
    params => "" +
      "404 Not Found",

    // `payment_unit_euro`:
    // Euro
    params => "" +
      "Euro",

    // `privacy-policies`:
    // privacy policies
    params => "" +
      "privacy policies",

    // `same-day-date-time-range`:
    // {date} • {time}
    params => [
      params.date,
      " • ",
      params.time,
    ],

    // `short-format-date`:
    // {date, date, short}
    params => "" +
      formatter_1(params.date),

    // `short-format-time`:
    // {date, time, short}
    params => "" +
      formatter_0(params.date),

    // `temporary-email-error`:
    // There seems to be an error with your email. Please try again later.
    params => "" +
      "There seems to be an error with your email. Please try again later.",

    // `terms-of-service`:
    // terms and conditions
    params => "" +
      "terms and conditions",

    // `time-range`:
    // {start} - {end}
    params => [
      params.start,
      " - ",
      params.end,
    ],

    // `unexpected-error-message`:
    // There was an unexpected error. Please try again.
    params => "" +
      "There was an unexpected error. Please try again.",

    // `yes`:
    // Yes
    params => "" +
      "Yes",
  ];
};
